import template from './users.edit.html';
import controller from './users.edit.controller';
import './users.edit.scss';

let userseditComponent = {
  restrict: 'E',
  bindings: {
    hasACL:'='
  },
  template,
  controller
};

export default userseditComponent;


// WEBPACK FOOTER //
// ./client/app/components/users/edit/users.edit.component.js